import React from 'react';
import { Provider } from 'react-redux';
import { IntercomProvider } from 'react-use-intercom';
// import { PersistGate } from 'redux-persist/integration/react';
import { AuthWidget, SnackbarWrapper } from './components';
import { store } from './core';

type Props = {
  children: React.ReactNode;
};

const AppProvider = ({ children }: Props) => {
  return (
    <IntercomProvider appId="fthmb1qz">
      <Provider store={store}>
        {/* <PersistGate loading={null} persistor={persistor}> */}
        <SnackbarWrapper>
          <AuthWidget>{children}</AuthWidget>
        </SnackbarWrapper>
        {/* </PersistGate> */}
      </Provider>
    </IntercomProvider>
  );
};

export default AppProvider;
